export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum LogAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum LogStatus {
  STARTED = 'started',
  RUNNING = 'running',
  FAILED = 'failed',
  RENDERED = 'rendered',
  SUCCEEDED = 'succeeded',
}

export type LogOutput = {
  status: LogStatus;
  action: LogAction | string;
  file?: string;
  event?: string;
  data?: any;
  user?: string;
  customer?: string;
  unit_id?: string;
  message?: string;
};

export type LoggingFacade = {
  [key: string]: Function | string;
  _file: string;
  get file(): string;
  set file(value: string);
  debug: (output: LogOutput) => void;
  info: (output: LogOutput) => void;
  warning: (output: LogOutput) => void;
  error: (output: LogOutput) => void;
};
